export default "__VITE_ASSET__DU14XqUx__"